module.exports = {
  firebase: {
    apiKey: "AIzaSyBfi3jTI8n6nHaN1m8FqUO5D-rXo4t2u28",
    authDomain: "mipymes.cloud",
    databaseURL: "https://pymes-cloud.firebaseio.com",
    projectId: "pymes-cloud",
    storageBucket: "pymes-cloud.appspot.com",
    messagingSenderId: "736923032246"
  },
  appName: 'miPyMEs.cloud'
}
